import { Container } from '@algbra/ui/components/Grid/Grid'
import Whitespace from '@algbra/ui/components/Whitespace/Whitespace'
import { GatsbyResolvedAsset } from '@algbra/ui/types/image'
import { resolveAsAttachment, resolveAsImage } from '@algbra/ui/resolvers'
import { mapIndexed } from 'rambdax'

import styles from './ContentWithLogo.module.scss'
import { GatsbyImage } from 'gatsby-plugin-image'
import classNames from 'classnames'

enum ImageWeightEnum {
  'right',
  'left',
}

export type ContentWithLogoItem = {
  id: string
  image: GatsbyResolvedAsset
}

export type ZoneContentWithLogoProps = {
  __typename: 'StrapiGQL_ComponentZonesContentWithLogo'
  description?: string
  image: GatsbyResolvedAsset
  items?: ContentWithLogoItem[]
  imageWeight: ImageWeightEnum
}

export function ContentWithLogoItem({
  image,
}: ContentWithLogoItem): JSX.Element {
  return (
    <div>
      <GatsbyImage image={resolveAsImage(image)} alt={'Algbra'} loading="lazy" />
    </div>
  )
}

export default function ZoneContentWithLogo({
  description,
  items,
  image,
  imageWeight,
}: ZoneContentWithLogoProps) {
  return (
    <Whitespace type="none">
      <Container>
        <GatsbyImage
          image={resolveAsImage(image)}
          alt={'title'}
          loading="lazy"
          className={classNames(styles.image, styles[imageWeight])}
        />
        <div className={styles.description}>{description}</div>
        <div className={styles.logoBlock}>
          {mapIndexed(
            (item: ContentWithLogoItem) => (
              <ContentWithLogoItem {...item} key={item.id} />
            ),
            items
          )}
        </div>
      </Container>
    </Whitespace>
  )
}
